import { useState, useEffect } from "react";

/**
 * Hook для определения мобильного устройства
 * @param breakpoint - медиа запрос для определения мобильного устройства (по умолчанию 768px)
 * @returns boolean - true если устройство мобильное
 */
export const useIsMobile = (breakpoint = "(max-width: 768px)"): boolean => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const mediaQuery = window.matchMedia(breakpoint);

    // Устанавливаем начальное значение
    setIsMobile(mediaQuery.matches);

    // Обработчик изменения медиа запроса
    const handleChange = (event: MediaQueryListEvent) => {
      setIsMobile(event.matches);
    };

    // Добавляем слушатель
    mediaQuery.addEventListener("change", handleChange);

    // Очистка при размонтировании
    return () => {
      mediaQuery.removeEventListener("change", handleChange);
    };
  }, [breakpoint]);

  return isMobile;
};
